import TemplateView from "../../../TemplateView";
import messageResource from "../../../messageResource";
import {userNameLower} from '../../../util/pluralizeUtils'

export default class SelectedUsersBlock extends TemplateView {

    constructor() {
        super()

        this.state = {
            assignedUsersCount: 0,
        }

        this.onStatePropertyChanged('assignedUsersCount', assignedUsersCount => {
            const label = `${assignedUsersCount} ${userNameLower(assignedUsersCount)}`
            this.getEl().text(label)
        })
    }

    templateHtml() {
        return "<div class='selectedUsersBlock'/>"
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/user/permissions/SelectedUsersBlock.js